module.exports = __webpack_public_path__ + "assets/img/30_789.d4c919da.jpg";